let _data_lens = [];
for (let id = 0; id < 10; id++) {
  let _len = {
    prikey: id,
    mf_key: id + 1,
    lenname: `lenname${id}`
  };
  for (let id = 0; id < 5; id++) {
    _len[`r${id}`] = (Math.random() * 10)._toFixed(2);
    _len[`width${id}`] = (Math.random() * 10)._toFixed(2);
    _len[`ecc${id}`] = (Math.random() * 10)._toFixed(2);
    _len[`toric_r${id}`] = (Math.random() * 10)._toFixed(2);
  }
  _data_lens.push(_len);
}
let _data_manuf = [];
for (let id = 0; id < 50; id++) {
  const manufFileds = {
    prikey: id,
    mfname: "mfname" + id,
    phone: "18045689854",
    address: "上海美沃精密仪器",
    createddate: "2019-09-10 12:00:55"
  };
  _data_manuf.push(manufFileds);
}
let _records = [
  {
    creationdate: "2019-12-30 20:13:08",
    _id: 1
  },
  { creationdate: "2015-11-21 20:13:08", _id: 2 },
  { creationdate: "2009-12-10 20:13:08", _id: 3 },
  { creationdate: "2013-10-30 20:13:08", _id: 4 }
];
export const dataManuf = _data_manuf.concat();
export const dataLens = _data_lens.concat();
export const records = _records.concat();

class _FillColor {
  constructor() {}
  InitColorMap() {
    return { ptr: undefined };
  }

  UpdateColorMapType() {}
  FreeColorMap() {}
  UpdateData() {
    return { result: 0 };
  }
  UpdateFlagData() {
    return { result: 0 };
  }
  UpdateDataPtr() {
    return 0;
  }
  UpdateColorNum() {}
  UpdateColorStyle() {}
  UpdateFlagDD() {}
  UpdateFlagRel() {}
  RefreshColorStyleScaleArray() {
    return { result: 0 };
  }
  GetCsArrayAndSiArray() {
    return { result: 0 };
  }
  RefreshColorMap() {
    return { result: 0 };
  }
  PixelValueAndColorIndex(index) {
    return { index: index };
  }
}
export const mockFillColor = new _FillColor();
let result = {
  result: -1
};
class _Zernike {
  constructor() {}
  InitZernikeMod(step) {
    return result;
  }
  ReadData(filepath) {
    return result;
  }
  UdateRpZnkOrder(order, diameter) {
    return result;
  }
  ComputeZnkPara() {
    return result;
  }
  GetUIParams() {
    let values = new Float64Array(66);
    values.fill(INVALID_1000);
    return values;
  }

  CalcZnkMap(indexes) {
    return result;
  }
  GetUIMaxXY() {
    return result;
  }
  GetUIColorMapData() {
    return null;
  }
  GetUIZnkparaKeys(indexes) {
    return result;
  }
  FreeZernikePtr(ptr) {}
}
export const mockZernike = new _Zernike();



// WEBPACK FOOTER //
// ./src/topography/js/mock.js